/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cerez_S3_R1_PurposeInputs */

const tr_cerez_s3_r1_purpose = /** @type {(inputs: Cerez_S3_R1_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Oturum yönetimi (kimlik doğrulama token'ı)`)
};

const en_cerez_s3_r1_purpose = /** @type {(inputs: Cerez_S3_R1_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Session management (authentication token)`)
};

const de_cerez_s3_r1_purpose = /** @type {(inputs: Cerez_S3_R1_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sitzungsverwaltung (Authentifizierungs-Token)`)
};

const ru_cerez_s3_r1_purpose = /** @type {(inputs: Cerez_S3_R1_PurposeInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Управление сессией (токен аутентификации)`)
};

/**
* | output |
* | --- |
* | "Session management (authentication token)" |
*
* @param {Cerez_S3_R1_PurposeInputs} inputs
* @param {{ locale?: "tr" | "en" | "de" | "ru" }} options
* @returns {LocalizedString}
*/
export const cerez_s3_r1_purpose = /** @type {((inputs?: Cerez_S3_R1_PurposeInputs, options?: { locale?: "tr" | "en" | "de" | "ru" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cerez_S3_R1_PurposeInputs, { locale?: "tr" | "en" | "de" | "ru" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cerez_s3_r1_purpose(inputs)
	if (locale === "de") return de_cerez_s3_r1_purpose(inputs)
	if (locale === "ru") return ru_cerez_s3_r1_purpose(inputs)
	return tr_cerez_s3_r1_purpose(inputs)
});